var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isLoading)?_c('div',[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"primary"}})],1):_c('div',[_c('app-form',{attrs:{"parentObject":{
            data: this.formData,
            searchnew: this.search,
            pageTitle: this.pageTitle,
            pageTitleValue: this.formData.simulationcode,
            errMsg: this.errMsg,
            isEdit: this.isEdit,
            pmRewardBasicSalaryDetailList: this.pmRewardBasicSalaryDetailList,
            pmRewardBonusDetailList: this.pmRewardBonusDetailList,
            pmRewardBonusPostingInstrucDetailList: this.pmRewardBonusPostingInstrucDetailList,
            pmRewardInstruction: this.pmRewardInstruction,
            pmRewardInstructionIsEdit: this.pmRewardInstructionIsEdit,
            pmRewardSalaryPostingInstruc: this.pmRewardSalaryPostingInstruc,
            pmRewardSalaryPostingInstrucIsEdit: this.pmRewardSalaryPostingInstrucIsEdit
        }},on:{"input":function($event){_vm.formData = $event},"save":_vm.saveHandler,"error":_vm.errorHandler}}),(_vm.isErr)?_c('div',[_c('app-error',{attrs:{"parentError":{
                data: this.errMsg,
                isErr: this.isErr,
            }},on:{"closeError":function($event){_vm.isErr = $event}}})],1):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }